module.exports = __webpack_public_path__ + "static/media/sho_activef92390f032e1cee0115f531e39c870fa.webp";